const uk = {
	appName: 'resolvo.me',
	welcomeMessage: 'Керуйте та відстежуйте свої новорічні рішення',
	signInToYourAccount: 'Увійдіть у свій акаунт',
	createYourAccount: 'Створіть свій акаунт',
	firstName: "Ім'я",
	lastName: 'Прізвище',
	emailAddress: 'Електронна пошта',
	password: 'Пароль',
	confirmPassword: 'Підтвердьте пароль',
	signUp: 'Реєстрація',
	signIn: 'Увійти',
	processing: 'Обробка...',
	dontHaveAccountSignUp: 'Немає акаунту? Зареєструйтесь',
	alreadyHaveAccountSignIn: 'Вже маєте акаунт? Увійдіть',
	resetPassword: 'Скинути пароль',
	sendResetEmail: 'Надіслати лист для скидання',
	sending: 'Надсилання...',
	rememberMe: 'Запам’ятати мене',
	forgotPassword: 'Забули пароль?',
	adminDashboard: 'Панель адміністратора',
	myDashboard: 'Мій дашборд',
	myProfile: 'Мій профіль',
	settings: 'Налаштування',
	signOut: 'Вихід',
	addResolution: 'Додати рішення',
	cancel: 'Скасувати',
	makePrivate: 'Зробити це рішення приватним (зашифровано)',
	encryptionKey: 'Ключ шифрування',
	enterEncryptionKey: 'Введіть безпечний ключ для шифрування рішення',
	rememberEncryptionKey: 'Запам’ятайте цей ключ! — він потрібен для перегляду приватного рішення',
	type: 'Тип',
	year: 'Рік',
	resolutionText: 'Текст рішення',
	exampleCount: 'наприклад: Прочитати 20 книг цього року',
	exampleBinary: 'наприклад: Купити нову машину',
	exampleMetric: 'наприклад: Скинути 10 кг до кінця року',
	startValue: 'Початкове значення',
	targetValue: 'Цільове значення',
	unit: 'Одиниця',
	unitExample: 'наприклад: кг, км, години, USD',
	exampleStreak: 'наприклад: Пити 2 л води щодня (реєструвати щодня)',
	currentStreak: 'Поточна серія',
	longestStreak: 'Найдовша серія',
	never: 'Ніколи',
	measurements: 'Вимірювання',
	lastLogDate: 'Дата останнього запису',
	daysInARow: 'днів підряд',
	dailyInARow: 'днів підряд',
	weeklyInARow: 'тижнів підряд',
	monthlyInARow: 'місяців підряд',
	period: 'Період',
	daily: 'Щодня',
	weekly: 'Щотижня',
	monthly: 'Щомісяця',
	value: 'Значення',
	note: 'Примітка',
	add: 'Додати',
	loading: 'Завантаження...',
	resolutions: 'Рішення',
	claimAccount: 'Вам слід претендувати на свій акаунт, щоб додавати рішення',
	timeUntilNewYear: 'Час до Нового року',
	contactAdmin: 'Зв’яжіться з адміністратором щодо ваших рішень...',
	verifyingLink: 'Перевірка вашого посилання...',
	invalidLink: 'Неправильне посилання',
	goToLogin: 'Перейти до входу',
	completeAccountClaim: 'Завершити підтвердження акаунту',
	emailVerifiedCreatePassword: 'Електронну пошту підтверджено! Створіть пароль для захисту акаунту.',
	accountLabel: 'Акаунт',
	createPasswordLabel: 'Створити пароль',
	confirmPasswordLabel: 'Підтвердити пароль',
	enterYourPassword: 'Введіть пароль',
	confirmYourPassword: 'Підтвердіть пароль',
	creatingAccount: 'Створення акаунту...',
	completeClaim: 'Завершити підтвердження',
	backToLogin: 'Повернутися до входу',
	passwordMismatch: 'Паролі не співпадають',
	passwordTooShort: 'Пароль має містити щонайменше 6 символів',
	invalidOrExpiredLink: 'Неправильне або прострочене посилання підтвердження',
	linkNotFound: 'Посилання підтвердження не знайдено або воно прострочене',
	linkExpiredRequestNew: 'Термін дії посилання завершився. Будь ласка, запросіть нове.',
	accountAlreadyClaimed: 'Цей акаунт вже підтверджено',
	failedToCreateAccount: 'Не вдалось створити акаунт. Спробуйте ще раз.',
	claimErrorGeneric: 'Під час підтвердження сталася помилка',
	resolution: 'рішення',
	total: 'всього',
	overallProgress: 'Загальний прогрес',
	progress: 'Прогрес',
	completed: 'Завершено',
	complete: 'Завершити',
	'waiting-completion': 'Очікує завершення',
	ahead: 'Попереду',
	behind: 'Поступає',
	'on-track': 'На шляху',
	failed: 'Не вдалося',
	private: 'Приватне',
	decrypt: 'Розшифрувати',
	delete: 'Видалити',
	backToPlrofile: '← Повернутися до профілю',
	customizeProfile: 'Налаштуйте свій профіль і переваги',
	displayNameHeading: 'Відображуване ім’я',
	displayNameHelp: 'Як ваше ім’я відображається у профілі',
	enterDisplayName: 'Введіть відображуване ім’я',
	currentlyShowing: 'Зараз відображається',
	emailPreferences: 'Налаштування електронної пошти',
	requiredForReceiving: 'Необхідно для отримання електронних повідомлень',
	weeklyStatusEmail: 'Щотижневий звіт електронною поштою',
	emailRequired: '(Потрібна електронна адреса)',
	timerStyle: 'Стиль таймера',
	chooseTimer: 'Оберіть, як має виглядати ваш таймер зворотного відліку',
	selected: 'Вибрано',
	preview: 'Попередній перегляд:',
	saving: 'Збереження...',
	saveSettings: 'Зберегти налаштування',
	count: 'Лічильник',
	binary: 'Так/Ні',
	metric: 'Метрика',
	streak: 'Серія',
	yes: 'Так',
	no: 'Ні',
	'timer.months': 'Місяці',
	'timer.days': 'Дні',
	'timer.hours': 'Години',
	'timer.minutes': 'Хвилини',
	'timer.seconds': 'Секунди',
	'timer.monthsShort': 'МІС',
	'timer.daysShort': 'ДН',
	'timer.hoursShort': 'ГД',
	'timer.minutesShort': 'ХВ',
	'timer.secondsShort': 'СЕК',
	'timer.monthsShortLower': 'міс',
	'timer.daysShortLower': 'дн',
	'timer.hoursShortLower': 'год',
	'timer.minutesShortLower': 'хв',
	'timer.secondsShortLower': 'с',
	'timer.yearEnded': '🎉 Рік завершено!',
	'timer.option.basic.name': 'Мінімалістичний в один рядок',
	'timer.option.basic.desc': 'Чистий і простий формат в один рядок',
	'timer.option.card.name': 'Кольорові картки',
	'timer.option.card.desc': 'Кольорові картки для кожної одиниці часу',
	'timer.option.clock.name': 'Стиль цифрового годинника',
	'timer.option.clock.desc': 'Жирний цифровий стиль годинника',
	'timer.option.circular.name': 'Стиль кільця прогресу',
	'timer.option.circular.desc': 'Сучасні кругові індикатори прогресу',
	'timer.option.flip.name': 'Анімація FlipCard',
	'timer.option.flip.desc': 'Анімовані картки (лише для десктопу)',
	'timer.option.icon.name': 'Текст з іконками',
	'timer.option.icon.desc': 'Емодзі з скороченим текстом',
	resolutionUpdatedSuccessfully: 'Рішення успішно оновлено!',
	errorUpdatingResolution: 'Помилка під час оновлення рішення',
	failedToUpdateResolution: 'Не вдалося оновити рішення',
	settingsUpdatedSuccessfully: 'Налаштування успішно оновлено!',
	errorDeletingResolution: 'Помилка під час видалення рішення',
	failedToDeleteResolution: 'Не вдалося видалити рішення',
	failedToUpdateSettings: 'Не вдалося оновити налаштування',
	settingsSavedSuccessfully: 'Налаштування успішно збережено!',
	failedToSaveSettings: 'Не вдалося зберегти налаштування',
	errorSavingSettings: 'Помилка під час збереження налаштувань',
	resolutionDeletedSuccessfully: 'Рішення успішно видалено!',
	landingHeroTitle: 'Перетворіть свої цілі на імпульс',
	landingHeroSubtitle:
		'resolvo.me допомагає визначати значущі рішення, відстежувати прогрес із наміром і перетворювати мрії на сталу звичку.',
	landingGetStarted: 'Почати',
	landingLearnMore: 'Дізнатися як це працює',
	landingAndroidComingSoon: '📱 Додаток Android скоро',
	landingAimTitle: 'Чому resolvo.me?',
	landingAimDesc:
		'Ми віримо у силу чітких цілей та послідовного відстеження. resolvo.me розроблено для людей, які прагнуть успіху — не через досконалість, а через прогрес.',
	landingMission1Title: 'Подолайте спад у лютому',
	landingMission1Desc:
		'Більшість новорічних рішень зазнають невдачі в лютому — не тому, що цілі погані, а тому, що ми припиняємо відстежувати.',
	landingMission2Title: 'Перетворіть наміри на дії',
	landingMission2Desc:
		'Справжні зміни приходять не лише від обіцянок. Вони приходять від щоденних виборів, тижневого аналізу та бачення накопичення прогресу.',
	landingMission3Title: 'Спрощуйте процес',
	landingMission3Desc:
		'Встановіть цілі, записуйте прогрес, отримуйте тижневий зворотний зв’язок і дивіться, що працює.',
	landingMission4Title: 'Побудуйте тривалий потенціал',
	landingMission4Desc: 'Тривалі зміни — це не про досконалість, а про послідовність.',
	landingFeature1Title: 'Кілька типів рішень',
	landingFeature1Desc: 'Виберіть метод відстеження, який підходить вашій меті',
	landingFeature2Title: 'Відстеження та візуалізація',
	landingFeature2Desc: 'Переглядайте прогрес через графіки, серії та важливі інсайти',
	landingFeature3Title: 'Щотижневі оновлення',
	landingFeature3Desc: 'Залишайтеся відповідальними з тижневими підсумками ел. поштою',
	landingFeature4Title: 'Безпечно та приватно',
	landingFeature4Desc: 'Ваші дані зашифровані. Ви володієте своїми цілями.',
	landingResolutionTypesTitle: 'Типи рішень',
	landingResolutionTypesSubtitle: 'Оберіть формат, який найкраще підходить для вашої мети',
	landingBinaryType: 'Бінарне (Так/Ні)',
	landingBinaryDesc: 'Прості щоденні перевірки для звичок та рутини',
	landingBinaryExample1: 'Купити нову машину',
	landingBinaryExample2: 'Знайти нову роботу',
	landingCountType: 'Підрахунок',
	landingCountDesc: 'Відстежуйте, скільки разів ви щось робите',
	landingCountExample1: 'Прочитати 20 книг цього року',
	landingCountExample2: 'Написати 50 дописів в блог цього року',
	landingMetricType: 'Метрика',
	landingMetricDesc: 'Відстежуйте числовий прогрес із початковим та цільовим значенням',
	landingMetricExample1: 'Скинути 10 кг до кінця року',
	landingMetricExample2: 'Заощадити $5,000 цього року',
	landingStreakType: 'Серія',
	landingStreakDesc: 'Будуйте послідовні дні успіху, щоб підсилити мотивацію',
	landingStreakExample1: 'Пити 2 л води щодня',
	landingStreakExample2: 'Писати 500 слів щодня для вашого роману',
	landingQuote1: 'Успіх — це результат щоденних звичок — не одноразових трансформацій.',
	landingQuote1Author: 'Джеймс Клір',
	landingQuote2: 'Таємниця прогресу — почати.',
	landingQuote2Author: 'Марк Твен',
	landingFeaturesTitle: 'Функції, створені для успіху',
	landingFeatureLogging: 'Запис в один клік',
	landingFeatureLoggingDesc: 'Записуйте прогрес за секунди, в будь-якому місці',
	landingFeatureHistory: 'Історія прогресу',
	landingFeatureHistoryDesc: 'Переглядайте всі свої записи та бачте, наскільки далеко ви зайшли',
	landingFeatureReminders: 'Розумні нагадування',
	landingFeatureRemindersDesc: 'Опціональні нагадування, щоб тримати вас на шляху',
	landingFeatureExport: 'Експортуйте свої дані',
	landingFeatureExportDesc: 'Завантажуйте свої дані будь-коли — вони ваші',
	landingCtaTitle: 'Готові зробити цей рік найкращим?',
	landingCtaDesc: 'Приєднуйтесь до тисяч людей, які вже працюють над своїми цілями.',
	landingCtaButton: 'Створіть своє перше рішення',
	landingFooterAbout: 'resolvo.me: Просто. Приватно. Створено для тих, хто дійсно хоче змін.',
	landingFooterContact: 'Питання? Зв’яжіться з нами або відвідайте додаток',
};

export default uk;
